import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT } from '../authentication/constants'

const initialState = fromJS({})

function planReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PLAN_REVISION:
      return state
        .set('gettingPlanRevision', true)
        .set('gettingPlan', true)
        .delete('planRevision')
        .delete('plan')
        .delete('getPlanRevisionError')
        .delete('getPlanError')
        .set('currentPlanId', action.planId)
    case actionTypes.GET_PLAN_REVISION_DONE:
      return state
        .set('gettingPlanRevision', false)
        .set('planRevision', action.planRevision)
    case actionTypes.GET_PLAN_REVISION_ERROR:
      return state
        .set('gettingPlanRevision', false)
        .set('getPlanRevisionError', action.error)
    case actionTypes.GET_PLAN_DONE:
      return state.set('gettingPlan', false).set('plan', action.plan)
    case actionTypes.GET_PLAN_ERROR:
      return state.set('gettingPlan', false).set('getPlanError', action.error)
    case actionTypes.CLEAR_CURRENT_PLAN:
      return state.delete('plan')

    case actionTypes.MOVE_PIN_TO_PLAN:
      return state.set('movingPinToPlan', true).delete('movePinToPlanError')
    case actionTypes.MOVE_PIN_TO_PLAN_DONE:
      return state.set('movingPinToPlan', false).set('pinMoved', action.pin)
    case actionTypes.CLEAR_PIN_MOVED:
      return state.set('pinMoved', undefined)
    case actionTypes.MOVE_PIN_TO_PLAN_ERROR:
      return state
        .set('movingPinToPlan', false)
        .set('movePinToPlanError', action.error)
    case actionTypes.REMOVE_MOVE_PIN_TO_PLAN_ERROR:
      return state.delete('movePinToPlanError')

    case actionTypes.SET_CURRENT_PLAN_ID:
      return state.set('currentPlanId', action.planId)
    case actionTypes.CLEAR_CURRENT_PLAN_ID:
      return state.delete('currentPlanId')

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default planReducer
